var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoustache(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 119.8 53.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2-2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.17,
    y: -4.88,
    width: 7.4,
    height: 24.67,
    transform: "translate(1.68 17.26) rotate(-71.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.2,
    y: 22.3,
    width: 17.12,
    height: 7.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.13,
    y: 41.39,
    width: 24.51,
    height: 7.4,
    transform: "translate(-15.85 8.24) rotate(-21.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.23,
    y: 33.29,
    width: 7.4,
    height: 24.67,
    transform: "translate(29.44 132.3) rotate(-71.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.48,
    y: 23.39,
    width: 17.12,
    height: 7.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.16,
    y: 4.3,
    width: 24.51,
    height: 7.4,
    transform: "translate(4.69 40.26) rotate(-21.9)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoustache);
export default __webpack_public_path__ + "static/media/moustache.d4ccb0a2.svg";
export { ForwardRef as ReactComponent };